module.exports = __webpack_public_path__ + "static/img/announcements@2x.92f5ccb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/announcements@2x.png
// module id = I4q/
// module chunks = 29